import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spinner, useIovation, useQuery } from 'shared';
import { setEdsCFEPagesVisited, setEdsLocationId, setEdsSDKPagesVisited, } from '../../slice';
import useIntroEDS from '../_hooks/useIntroEDS';
import { useEDSStore } from '../_store/eds.store';
import { gotoApplications } from '../_utils/gotoURL';
import DisabledEDS from '../DisabledEDS';
import IntroFormEDS from './IntroFormEDS';
const IntroEDS = () => {
    // Hooks
    const history = useHistory();
    const { queryObject } = useQuery();
    const locationId = queryObject.get('locationId');
    const [getBlackboxData] = useIovation();
    const { postCreateCreditApp, dataFeatureFlags, locationData, isFetchingLocation, } = useIntroEDS({
        locationId,
    });
    // Store
    const { edsEnabled } = useEDSStore();
    const dispatch = useDispatch();
    // Func - Handle submit callback
    const handleSubmitCallback = async (data) => {
        // Blackbox data
        const blackboxData = getBlackboxData();
        // Post - Create Credit Application
        const resp = await postCreateCreditApp({
            postConsumerApplicationsV2CreditApplicationsCreate: {
                source: 'eds',
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                ...{ specialty: data.specialty ? data.specialty : undefined },
                ...{ locationId: data.locationId ? data.locationId : undefined },
                prerequisiteTermsAccepted: [
                    {
                        termContentId: 1,
                        acceptedOn: new Date().toISOString(),
                    },
                ],
                iovationBlackBox: blackboxData,
                ssn: '',
                dateOfBirth: '',
                annualIncome: 0,
                street1: '',
                city: '',
                state: '',
                zip: '',
                primaryPhone: '',
            },
        });
        if ('error' in resp) {
            if ('error' in resp.error) {
                /* Error Message  - Left blank intentionally in case the application needs further user action */
            }
        }
        else {
            // Push to next page
            dispatch(setEdsLocationId(data.locationId));
            pushToNext({
                applicationInfo: resp.data,
                blackboxData: blackboxData,
                formData: data,
            });
        }
    };
    // Func - Push to next page
    const pushToNext = ({ applicationInfo, blackboxData, formData, }) => {
        // Store Data
        useEDSStore.setState({
            edsInfoForm: {
                ...formData,
            },
            edsApplicant: {
                ...applicationInfo,
            },
            blackboxData: blackboxData,
        });
        gotoApplications(history);
    };
    useEffect(() => {
        if (dataFeatureFlags) {
            const FF = dataFeatureFlags.featureFlags;
            if (FF.consumerEds) {
                // Enable EDS
                useEDSStore.setState({
                    edsEnabled: true,
                });
            }
            if (FF.consumerEds === false) {
                // Disable EDS
                useEDSStore.setState({
                    edsEnabled: false,
                });
            }
        }
    }, [dataFeatureFlags]);
    useEffect(() => {
        dispatch(setEdsCFEPagesVisited([]));
        dispatch(setEdsSDKPagesVisited([]));
    }, []);
    return (_jsxs("div", { className: "max-width-800 mar-auto", children: [edsEnabled && (_jsx(IntroFormEDS, { submitCallback: handleSubmitCallback, locationData: locationData, isFetchingLocation: isFetchingLocation })), edsEnabled === null && _jsx(Spinner, {}), edsEnabled === false && _jsx(DisabledEDS, {})] }));
};
export default IntroEDS;
